import { Link } from "fusion-plugin-react-router";
import { assetsPath } from "../../../../shared/utils/assetsPath";
import PortalCard from "../dashboard/PortalCard";

const ERSClaimSection = () => {
  const handleCall = () => {
    window.open("tel:03301235591", "_self");
  };
  return (
    <section className="claim-contact-section">
      <h1 className="welcome-text">Get in touch with our team</h1>
      <div className="grid">
        <PortalCard
          heading="Call"
          text="Report your claim as soon as possible by calling 0330 123 5591"
          image={assetsPath.call}
          onClick={handleCall}
          button="Call Now"
          className="width-250"
        />
      </div>
      <Link to="/landing" className="prevBtn margin-top-40">
        <img className="PrevImg" src={assetsPath.previous} alt="Previous" />
      </Link>
    </section>
  );
};

export default ERSClaimSection;
